import { createReducer } from 'typesafe-actions'
import {
    setGlobalEquipmentSearchQueryState,
    clearGlobalEquipmentSearchQueryState,
    setSearchModeState,
    resetSearchModeState,
} from '../actions/app/equipmentGlobalSearch.actions'

export interface GlobalEquipmentSearchState {
    query: string
    searchMode: 'page' | 'global'
}

export const defaultState: GlobalEquipmentSearchState = {
    query: '',
    searchMode: 'page',
}

const globalEquipmentSearchReducer = createReducer(defaultState)
    .handleAction(setGlobalEquipmentSearchQueryState, (state, action) => ({
        ...state,
        query: action.payload,
    }))
    .handleAction(clearGlobalEquipmentSearchQueryState, (state) => ({
        ...state,
        query: '',
    }))
    .handleAction(setSearchModeState, (state, action) => ({
        ...state,
        searchMode: action.payload,
    }))
    .handleAction(resetSearchModeState, (state) => ({
        ...state,
        searchMode: 'page',
    }))

export default globalEquipmentSearchReducer
